import { SxProps, Theme } from '@mui/material';

const selectedItem: SxProps<Theme> = (theme) => ({
  borderLeft: '3px solid',
  borderColor: theme.palette.primary.main,
});

const alignedCentered: SxProps<Theme> = {
  textAlign: 'center',
};

export default { selectedItem, alignedCentered };
